import { UserApprovalChanged } from "../api/ticket/subscriptions/UserApprovalChanged";
import { useSignalRSubscription } from "../hooks/useSignalRSubscription";

export const ConciergeUserUpdatesInitializer = () => {
    useSignalRSubscription(UserApprovalChanged);

    return null;
};
